define('shoptheme/components/plugin/shariff',[
	"jquery",
	"cartware/components/_base",
	"shariff"
], function(
	$,
	Component
) {

	return Component.create({
		$init: function () {
			// new Shariff($(".shariff"), {
			// 	orientation: 'horizontal',
			// 	services: ['facebook', 'twitter', 'googleplus'],
			// 	theme: 'grey',
			// 	col: 3
			// });
		}
	});
});
